import { useInfiniteQuery } from "@tanstack/react-query";
import { getNotificationList } from "apis/notification";
import QUERY_KEYS from "config/queryKey";

const useNotificationListQuery = (isUser?: boolean) => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.notifications],
    queryFn: ({ pageParam }) =>
      getNotificationList({
        page: pageParam,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) =>
      !lastPage.last ? lastPage.number + 1 : null,
    enabled: !!isUser,
  });
};

export default useNotificationListQuery;
